<dialog
  #dialog
  class="esn-modal"
  [class.esn-modal--inline]="inline()"
  [style.width.px]="size()"
  [attr.aria-labelledby]="titleId"
  (cancel)="handleCancel($event)"
  (click)="handleClick($event)"
>
  <div class="esn-modal__panel">
    <header class="esn-modal__header">
      <h2 class="esn-modal__title" [id]="titleId">{{ title() }}</h2>
      <button type="button" class="esn-modal__close" [attr.aria-label]="closeLabel()" (click)="dismiss('close')">
        <esn-icon name="close" [size]="24" />
      </button>
    </header>
    <div class="esn-modal__body"><ng-content /></div>
    <footer class="esn-modal__footer"><ng-content select="[esnModalFooter]" /></footer>
  </div>
</dialog>
